'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Break = undefined;

var _themeProvider = require('@spp/theme-provider');

var _Break = require('./Break');

var _Break2 = _interopRequireDefault(_Break);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.Break = _Break2.default;
exports.default = (0, _themeProvider.themer)('@spp/ui-break')(_Break2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-break/lib/cjs/index.js
 ** module id = 576
 ** module chunks = 1
 **/